import React, { useEffect } from "react";
import {
  FlatList,
  Image,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import moment from "moment";

const ChatComponent = ({
  styles,
  chatData,
  selectedButton,
  setSelectedButton,
  renderChatMessages,
  flatListRef,
  newMessage,
  setNewMessage,
  sendComment,
  chatOpen,
  setChatOpen,
  addNewMessage,
  userData,
  eventId,
}) => {
  const handleSendMessage = () => {
    if (newMessage.trim() === "") {
      alert("Please enter a message.");
      return;
    }

    const newChatEntry = {
      commentData: newMessage.trim(),
      commentId: Date.now().toString(),
      userId: userData.username,
      eventId: eventId,
      commentType: selectedButton,
      timestamp: Date.now(),
    };

    sendComment(userData.username, eventId, newMessage.trim(), selectedButton);

    addNewMessage(newChatEntry);

    setNewMessage("");
    flatListRef.current?.scrollToEnd({ animated: true });
  };

  const handleTextChange = (text) => {
    if (text.endsWith("\n")) {
      handleSendMessage();
    } else {
      setNewMessage(text);
    }
  };

  return (
    <View
      style={{
        backgroundColor: AppColors.gray_1E1E1E,
        borderRadius: 10,
        marginVertical: 10,
        borderWidth: 1,
        borderColor: AppColors.grayColor_505050,
        padding: 10,
        flex: chatOpen ? 1 : null,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          columnGap: 10,
        }}
      >
        <Text style={[AppFontStyle.BOLD_ANYBODY_18, { flex: 1 }]}>Chat</Text>
        <TouchableOpacity onPress={() => setChatOpen(!chatOpen)}>
          <Image
            source={chatOpen ? AppImages.icUpLineArrow : AppImages.arrowDown}
            style={{ height: 18, width: 18, alignSelf: "center" }}
            resizeMode="contain"
          />
        </TouchableOpacity>
      </View>
      <View
        style={{
          height: 1,
          backgroundColor: AppColors.grayColor_505050,
          marginTop: 5,
          marginBottom: chatOpen ? 10 : 0,
        }}
      />
      {chatOpen && (
        <>
          <View
            style={{
              flexDirection: "row",
              backgroundColor: AppColors.grayColor_505050,
              borderRadius: 10,
              justifyContent: "space-between",
              marginVertical: 18,
              padding: 10,
            }}
          >
            {["Players", "Audience", "Moderator"].map((tab) => (
              <TouchableOpacity
                key={tab}
                onPress={() => setSelectedButton(tab)}
                style={[
                  styles.btnTeam,
                  {
                    backgroundColor:
                      selectedButton === tab
                        ? AppColors.gray_1E1E1E
                        : AppColors.grayColor_333333,
                    borderRadius: 10,
                  },
                ]}
              >
                <Text style={AppFontStyle.REGULAR_ANYBODY_12}>{tab}</Text>
              </TouchableOpacity>
            ))}
          </View>
          <View
            style={{
              borderWidth: 1,
              borderColor: AppColors.gray_A3A3A3,
              padding: 10,
              borderRadius: 10,
              flex: 1,
            }}
          >
            <FlatList
              data={chatData}
              renderItem={renderChatMessages}
              ref={flatListRef}
              keyExtractor={(item) => item.commentId}
              onContentSizeChange={() =>
                flatListRef.current?.scrollToEnd({ animated: true })
              }
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{
                height: 200,
              }}
              scrollIndicatorInsets={{ right: 1 }}
            />
            <View
              style={{
                height: 2,
                backgroundColor: AppColors.gray_A3A3A3,
                marginBottom: 7,
                marginTop: 10,
              }}
            />
            <View
              style={{
                flexDirection: "row",
                marginTop: 8,
                columnGap: 10,
              }}
            >
              <TextInput
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    flex: 1,
                    backgroundColor: "white",
                    borderRadius: 10,
                    paddingHorizontal: 7,
                    paddingVertical: 15,
                    color: "black",
                  },
                ]}
                multiline={true}
                placeholderTextColor="#989898"
                placeholder="Write your message..."
                value={newMessage}
                onChangeText={handleTextChange}
              />
              <TouchableOpacity
                onPress={handleSendMessage}
                style={{
                  backgroundColor: AppColors.purpleColor_9D2CF5,
                  height: 60,
                  width: 60,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 10,
                }}
              >
                <Image
                  source={AppImages.arrowUp}
                  style={{
                    height: 32,
                    width: 32,
                    resizeMode: "contain",
                    marginVertical: 10,
                  }}
                />
              </TouchableOpacity>
            </View>
          </View>
        </>
      )}
    </View>
  );
};

export default ChatComponent;
